import GoogleMapReact from "google-map-react";

import MapPin from "../../assets/svg/map_pin";

const AnyReactComponent = ({ text }) => <MapPin />;

export default function Index({ height }) {
  return (
    <div style={{ height, width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
        }}
        defaultCenter={{
          lat: 22.87253962416666,
          lng: 72.41069924399642,
        }}
        defaultZoom={13}
        yesIWantToUseGoogleMapApiInternals
      >
        <AnyReactComponent
          lat={22.87253962416666}
          lng={72.41069924399642}
        />
      </GoogleMapReact>
    </div>
  );
}
